export const getCurrencyFormat = ({ value }) => {
  if (value === null || value === undefined || value === '' || isNaN(value)) {
    return value
  }
  return new window.Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  }).format(value)
}

export const getNumberFormat = ({ value }) => {
  if (value === null || value === undefined || value === '' || isNaN(value)) {
    return value
  }
  return new window.Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}
